<template>
    <div>
        <b-button :to="{name: add.link}" exact class="btn btn-orange mr-2">
            <i :class="add.icon"></i> {{add.label}}
        </b-button>
        <slot></slot>
    </div>
</template>

<script>
  export default {
    props: {
      add: {
        type: Object
      },
      export: {
        type: String,
        default: ''
      }
      // links: {
      //   type: Array,
      //   default: []
      // },
      // buttons: {
      //   type: Array,
      //   default: []
      // }
    },
    data() {
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/TableListActions.vue